export const defaultMessages = {
    UNKNOWN_ERROR: 'Неизвестная ошибка',
    SOMETHING_WENT_WRONG: 'Что-то пошло не так',
    ACCESS_DENIED: 'Недостаточно прав для этого действия',
    INVALID_DATA: 'Проверьте заполнение полей: часть значений не прошла проверку',
};

export const clientMessages = {};

export const serverErrors = {};

export const serverMessages = {};

/**
 * Errors whose server message is already a finished, user-facing Russian sentence naming the field
 * that failed ("Поле «Кому» обязательно для заполнения"). A static per-title mapping cannot carry
 * that, so these are shown as-is instead of being flattened into "Что-то пошло не так".
 */
export const passThroughErrors = ['FormFieldValidation', 'DictionaryInUse'];

export default defaultMessages;
